import { getAgingColumns, getAgingRows } from "./aging-statement";
import { getCustomerAging } from "@/api/finance/reportApi";
import {
  DynamicReport
} from "@/components/dynamic";
import { formatApiPayloadDate } from "@/utils/helpers";

const agingFilters = {
  BuildingId: "*",
  TenantId: "*",
  ComponentId: "*",
  ContractId: "*",
  TransactionDate: formatApiPayloadDate(new Date())
};

// Building/Tenant/Component/Contract dropdowns show a human-readable label (number or name)
// but submit the record's id (matched against the record's Key on the backend), so these must
// read .value, not .label - no keyType here falls through to the default .value branch.
const agingFilterOptions = [
  { key: "buildingNumber", apiKey: "BuildingId" },
  { key: "tenantNumber", apiKey: "TenantId" },
  { key: "componentNumber", apiKey: "ComponentId" },
  { key: "contractNumber", apiKey: "ContractId" },
  { key: "transactionDate", apiKey: "TransactionDate", keyType: "date" },
];

export default function RentRollReport({ activeCompany }) {
  return (
    <DynamicReport
      reportName="customer-aging"
      isPaginated
      activeCompany={activeCompany}
      columnsDataProvider={getAgingColumns}
      rowsDataProvider={getAgingRows}
      fetchData={getCustomerAging}
      exportUrl="leasing/reports/customer-aging/xls"
      filtersInitialState={agingFilters}
      showDateRangeFilter={false}
      showSearchFilter={false}
      filterOptions={agingFilterOptions}
      orderBy="ComponentNumber"
    />
  );
}
